<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-amzPriceControl',
  components: { PageTable },
}
</script>
